import { useAuth } from "../services/auth-context";
import { ManagerDashboardPage } from "./manager/Dashboard";
import { EmployeeRankingPage } from "./employee/Ranking";

/** The `/company/:slug/dashboard` route is shared in the sidebar (both roles show "Dashboard"),
 * but the content differs sharply per FR-017 vs. FR-043: a Manager gets the full dashboard, a
 * non-Manager employee gets the ranking-only view. */
export function DashboardRouter() {
  const { auth } = useAuth();
  if (auth?.role === "member" && auth.isManager) return <ManagerDashboardPage />;
  return <EmployeeRankingPage />;
}
